import React, { PureComponent } from 'react';

import { ButtonIcon } from 'components/button';
import { Dropdown, DropdownItem } from 'components/dropdown';
import { I18n } from 'components/translate';
import { UiService } from 'modules/ui';
import { ALERT } from 'modules/ui/constants';
import { UserManagerService, UserManagerStore } from 'modules/userManager';
import { USER_STATUS, ACTIONS } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import DeleteUserModal from './DeleteUserModal';
import { changeStatus } from './helpers/changeStatus';
import { handleError } from './helpers/handleError';
import { isToggleReasonModalEnabled } from './helpers/toggleReasonModal';

import './UsersSingleActions.scss';

const actions = {
  changeStatus: 'CHANGE_STATUS',
  delete: 'DELETE'
};

class UsersSingleActions extends PureComponent {
  // #region setup
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    toggleUserReasonBlockModal: PropTypes.func
  };

  state = {
    showDeleteModal: false
  };

  constructor(props) {
    super(props);

    this.resendAccess = this.resendAccess.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.toggleReasonBlockModal = this.toggleReasonBlockModal.bind(this);
    this.getActionChangeStatus = this.getActionChangeStatus.bind(this);
  }

  async updateChangeStatus() {
    const { onUpdate } = this.props;
    const form = null;

    await changeStatus(form, onUpdate);
  }

  getActionChangeStatus = () => {
    const { user } = this.props;
    const userIsActive = this.userIsActive;

    if (user && user?.id) {
      UserManagerStore.selectedConsumer = user;
    }

    if (!userIsActive) {
      return this.updateChangeStatus();
    }

    return isToggleReasonModalEnabled()
      ? this.toggleReasonBlockModal()
      : this.updateChangeStatus();
  };

  get actionsList() {
    const { user } = this.props;
    const actionsPath = 'users_manager.users_list.bulk_actions';
    const userIsActive = this.userIsActive;

    const actions = [
      {
        id: userIsActive ? ACTIONS.BLOCK : ACTIONS.UNBLOCK,
        icon: userIsActive ? 'lock' : 'unlock',
        label: userIsActive ? 'general.block' : 'general.unblock',
        handler: this.getActionChangeStatus
      }
    ];

    user.deletable &&
      actions.unshift({
        id: ACTIONS.DELETE,
        icon: 'delete',
        label: 'general.exclude',
        handler: this.toggleDeleteModal
      });

    userIsActive &&
      actions.unshift({
        id: ACTIONS.RETRY,
        icon: 'retry',
        label: `${actionsPath}.resend_access`,
        handler: this.resendAccess
      });

    return actions;
  }

  async resendAccess() {
    try {
      await UserManagerService.resendAccess(this.userId);
      this.handleSuccess();
    } catch (error) {
      handleError(error);
    }
  }

  getChangeStatusData({
    userId,
    status,
    blockReason = null,
    blockReasonDescription
  }) {
    if (status === USER_STATUS.ACTIVE) {
      return {
        userId,
        status
      };
    }

    return {
      userId,
      status,
      ...(blockReason && { blockReason }),
      ...(blockReasonDescription && { blockReasonDescription })
    };
  }

  get userId() {
    const { user } = this.props;

    return user && user.id;
  }

  get userIsActive() {
    const { userStatus } = this.props.user;

    return userStatus && UserManagerService.userIsActive(userStatus);
  }

  toggleDeleteModal = () => {
    this.setState((prevState) => ({
      showDeleteModal: !prevState.showDeleteModal
    }));
  };

  toggleReasonBlockModal = () => {
    const { toggleUserReasonBlockModal } = this.props;

    toggleUserReasonBlockModal && toggleUserReasonBlockModal();
  };

  handleSuccess(message = 'done', timeout = ALERT.TIMEOUT.LONG) {
    UiService.setAlertSuccess(message, {}, timeout);
  }

  handleSuccessUpdate(eventType, message = 'done') {
    const { onUpdate } = this.props;

    this.handleSuccess(message);

    onUpdate(eventType);
  }

  render() {
    const { showDeleteModal } = this.state;

    return (
      <>
        <Dropdown
          className="user__actions__dropdown"
          classNameMenu="user__actions__dropdown__menu"
          classNameToggle="user__actions__dropdown__toggle"
        >
          {this.actionsList.map((action) => {
            return (
              <DropdownItem key={action.id} onClick={action.handler}>
                <ButtonIcon
                  id={action.id}
                  icon={action.icon}
                  size="small"
                  transparent
                >
                  <I18n label={action.label} />
                </ButtonIcon>
              </DropdownItem>
            );
          })}
        </Dropdown>

        {showDeleteModal && (
          <DeleteUserModal
            handleSuccess={() => this.handleSuccessUpdate(actions.delete)}
            toggleModal={this.toggleDeleteModal}
            userId={this.userId}
          />
        )}
      </>
    );
  }
}

export default UsersSingleActions;
